module.exports = __webpack_public_path__ + "img/noir.86213ae8.jpeg";